import ActionTypes from './../Action/ActionTypes';

let preference = {
  assetName: '',
  currentShiftEnd: '',
  currentShiftStart: '',
  path: '',
  preferences: {
    businessTeam: '',
    console: '',
    post: '',
    site: '',
  },
  previousShiftEnd: '',
  previousSHiftStart: '',
  previousSet: true,
  shiftName: '',
};
export default function PreferenceReducer(preState = { preference: preference }, action) {
  // { shiftLogs: [], isLoading: true }
  switch (action.type) {
    case ActionTypes.GET_PREFERENCE: {
      return { preference: { ...action.payload } };
    }

    default:
      return preState;
  }
}
